import Swiper from 'swiper/bundle';

window.Swiper = Swiper;

$(document).ready(function() {

    if ($('[data-gallery="project"]').length) {

        var $prev = $('[data-gallery="project"]').parents('.section').find('.swiper-button-prev'),
            $next = $('[data-gallery="project"]').parents('.section').find('.swiper-button-next')


        var mySwiper = new Swiper('[data-gallery="project"]', {
            speed: 300,
            grabCursor: true,
            spaceBetween: 32,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: $next.get(0),
                prevEl: $prev.get(0),
            },
            breakpoints: {

                300: {
                    slidesPerView: 1,
                },

                768: {
                    slidesPerView: 3,
                },

                1200: {
                    slidesPerView: 3,
                }
            }
        });
    }


});